import IconWrapper, {
  IconWrapperProps,
} from "@repo/ui/src/components/IconWrapper";

const AlertIcon = ({ ...rest }: IconWrapperProps) => (
  <IconWrapper
    viewBox="0 0 24 24"
    width="24"
    {...rest}
  >
    <circle cx="12" cy="12" r="12" fill="#E03D24"/>
    <path 
      fillRule="evenodd" 
      clipRule="evenodd" 
      d="M7.75744 6.34315L6.34323 7.75736L10.5859 12L6.34323 16.2426L7.75744 17.6569L12.0001 13.4142L16.2427 17.6569L17.6569 16.2426L13.4143 12L17.6569 7.75736L16.2427 6.34315L12.0001 10.5858L7.75744 6.34315Z" 
      fill="white"
    />
  </IconWrapper>
);

export default AlertIcon;
